export const HTTP_SUCCESS_OK = 200;

export const HTTP_REDIRECTION_MOVED_PERMANENTELY = 301;
export const HTTP_REDIRECTION_FOUND = 302;
export const HTTP_REDIRECTION_SEE_OTHER = 303;

export const HTTP_CLIENT_ERROR_BAD_REQUEST = 400;
export const HTTP_CLIENT_ERROR_UNAUTHORIZED = 401;
export const HTTP_CLIENT_ERROR_FORBIDDEN = 403;
export const HTTP_CLIENT_ERROR_NOT_FOUND = 404;

export const HTTP_SERVER_INTERNAL_ERROR = 500;
export const HTTP_SERVER_NOT_IMPLEMENTED = 501;
export const HTTP_SERVER_PROXY_ERROR = 502;
export const HTTP_SERVER_SERVICE_UNAVAILABLE = 503;
export const HTTP_SERVER_GATEWAY_TIMEOUT = 504;
